const endPointURLs = {
  // User
  UserMarketingId: () => '/agency/v1/user/marketing_id',

  // IAM
  IAMAssignedPermission: () => '/user-iam/permission/assigned',

  // IAM Mock for non prod
  IAMAssignedPermissionMock: () => '/agency/internal/permission/assigned',

  // General
  General: () => '/master/v1/general',
  Search: () => '/onboarding/address/search',
  SearchCity: () => '/onboarding/address/search_city',
  Banks: () => '/onboarding/master/banks',
  Occupations: () => '/onboarding/master/occupations',

  // Employees
  Employee: () => '/agency/v1/employee',

  // Head Office
  RegionList: () => '/agency/v1/region/list',
  AreaList: () => '/agency/v1/area/list',

  // Area
  AreaPerformance: () => '/agency/v1/area/performance',
  AreaPerformanceDays: () => '/agency/v1/area/performance/days',

  // Branch
  BranchList: () => '/agency/v1/branch',
  BMList: () => '/agency/v1/bm/list',
  BranchPerformance: () => '/agency/v1/branch/performance',

  // Supervisors
  SupervisorPerformanceV2: () => '/agency/v2/spv/performance',
  SPVList: () => '/agency/v1/spv/list',
  SupervisorPerformanceDays: () => '/agency/v1/spv/performance/days',

  // ARE
  AREPerformance: () => '/agency/v1/are/performance',
  AREPerformanceV2: () => '/agency/v2/are/performance',
  AREList: () => '/agency/v1/are/list',
  AREListBranch: () => '/agency/v1/are/list/branch',
  AREListTarget: () => '/agency/v1/are/list/target',
  ARETarget: () => '/agency/v1/are/target',
  AREBaselineTarget: () => '/agency/v1/are/baseline/target',
  AREHistoricalMonths: () => '/agency/v1/are/historical/months',
  AREHistoricalAverageV2: () => '/agency/v2/are/performance/historical/average',

  // Agents
  AgentPerformance: () => '/agency/v1/agent/performance',
  AgentPerformanceMatrix: () => '/agency/v1/agent/performance/matrix',
  AgentPerformanceAll: () => '/agency/v1/agent/performance/agent/all',
  AgentPerformanceHistoricalAverage: () =>
    '/agency/v2/agent/performance/historical/average',
  AgentMonthlyPerformance: () => '/agency/v2/agent/monthly/performance',
  AgentList: () => 'agency/v1/agent/list',
  AgentListBlacklist: () => 'agency/v1/agent/list/blacklists',
  AgentDetailBravo: (agentId: string) =>
    `agency/v1/agent/detail/bravo/${agentId}`,
  AgentBanHistory: (agentId: string) =>
    `agency/v1/agent/ban/history/${agentId}`,
  AgentActiveList: () => '/agency/v1/agent/active/list',
  AgentInactiveList: () => '/agency/v1/agent/inactive/list',
  AgentDetail: (agentMarketingId: string) =>
    `/agency/v1/agent/detail/${agentMarketingId}`,
  Agent: () => '/agency/v1/agent',
  AgentV2: () => '/agency/v2/agent',
  AgentDeactivate: (agentMarketingId: string) =>
    `/agency/v1/agent/${agentMarketingId}/deactivate`,
  AgentReassign: (agentMarketingId: string) =>
    `/agency/v1/agent/${agentMarketingId}/reassign`,
  AgentPhoneNumber: (agentMarketingId: string) =>
    `/agency/v1/agent/${agentMarketingId}/phone_number`,
  AgentMaintainable: () => '/agency/v1/agent/maintainable',
  AgentMaintainableV2: () => '/agency/v2/agent/maintainable',
  AgentReactivate: (agentMarketingId: string) =>
    `/agency/v2/agent/${agentMarketingId}/reactivate`,
  AgentRecommendationList: () => '/agency/v1/agent/recommendation/list',
  AgentDocumentUnsigned: () => '/agency/v1/agent/document/unsigned',
  AgentUnsignedList: () => '/agency/v1/agent/unsigned/list',

  // Maintain Activity
  MaintainARESchedule: () => '/agency/v1/maintain/schedule',
  MaintainAssignment: () => '/agency/v1/maintain/assignment',
  MaintainAssignmentAreList: () => '/agency/v1/maintain/assignment/are/list',
  MaintainReportDetail: () => '/agency/v1/maintain/report/detail',
  MaintainActivityReport: () => '/agency/v1/maintain/report/activity',
  MaintainActivityReportV2: () => '/agency/v1/maintain/activity/report',

  // Recruit Activity
  RecruitAssignment: () => '/agency/v1/recruit/assignment',
  RecruitAll: () => '/agency/v2/recruit/all',
  RecruitWeeklyTarget: () => '/agency/v1/recruit/target',
  RecruitAgent: (agentRecruitId: string) =>
    `/agency/v1/recruit/agent/${agentRecruitId}`,
  RecruitAgents: () => '/agency/v1/recruit/agents',
  RecruitPerformanceAreaV2: () => 'agency/v2/recruit/performance/area',
  RecruitPerformanceArea: () => 'agency/v1/recruit/performance/area', // NOTE: v1 is newer than v2, for some reason this API start with v2, instead of using v3 as the new version team decide to use v1
  RecruitReport: () => 'agency/v1/recruit/report',
  RecruitActivityReport: () => 'agency/v1/recruit/activity/report', // NOTE: newer version of agency/v1/recruit/report

  // Onboarding Agent
  MaintainNonRegistARESchedule: () =>
    '/agency/v1/maintain/non-registered/schedule',
  MaintainNonRegistAssignment: () =>
    '/agency/v1/maintain/non-registered/assignment',
  MaintainNonRegistAssignmentAreList: () =>
    '/agency/v1/maintain/non-registered/assignment/are/list',
  MaintainNonRegistReportDetail: () =>
    '/agency/v1/maintain/non-registered/report/detail',
  MaintainNonRegistActivityReport: () =>
    '/agency/v1/maintain/non-registered/report/activity',
  MaintainNonRegistActivityReportV2: () =>
    '/agency/v1/maintain/non-registered/activity/report',
  AgentNonRegisteredMaintainable: () =>
    '/agency/v1/agent/non-registered/maintainable',

  // Join Visit
  JoinVisitAreList: () => '/agency/v1/join-visit/are/list',
  JoinVisitReport: () => '/agency/v1/join-visit/report',
  JoinVisitReportV2: () => '/agency/v2/join-visit/report',
  JoinVisitQuestionList: () => '/agency/v1/join-visit/question',
  JoinVisitSummary: () => '/agency/v1/join-visit/summary',
  JoinVisitFeedbackSummarySPV: () =>
    '/agency/v1/join-visit/feedback/summary/spv',

  // Leads Tracker
  AREApplicationDetail: () => '/agency/v1/are/application/detail',
  SupervisorNotes: () => '/agency/v1/supervisor/application/agency/property',
  SupervisorNotesUpdate: (notesId: string) =>
    `/agency/v1/supervisor/application/agency/property/${notesId}`,
  LeadsTrackerList: () => 'agency/v1/are/application/prospect/list',

  // 1 on 1
  OneOnOneAREList: () => 'agency/v1/one-on-one/are/list',
  OneOnOneAREListV2: () => 'agency/v2/one-on-one/are/list',
  OneOnOneActionPlan: () => 'agency/v1/one-on-one/action-plan',
  OneOnOneActionPlanV2: () => 'agency/v2/one-on-one/action-plan',
  OneOnOneActionPlanSpv: () => 'agency/v1/one-on-one/action-plan/spv',
  OneOnOneSpvAreReportCount: () => 'agency/v1/one-on-one/count/are',
  AverageMaintainRating: () => 'agency/v1/maintain/rating/average',
  AggregatedMaintainFeedback: () => 'agency/v1/maintain/feedback',
  ARERecruitPerformance: () => 'agency/v1/recruit/performance/are',
  ARERecruitPerformanceV2: () => 'agency/v2/recruit/performance/are',

  // Notification
  Notification: () => 'agency/v1/notification',
  NotificationMarkAsRead: () => 'agency/v1/notification/mark-as-read',
  NotificationRead: (notificationId: string) =>
    `agency/v1/notification/${notificationId}/read`,

  // Weekly Meeting
  GroupMeetingReport: () => 'agency/v1/group-meeting/report',
  GroupMeetingDetail: (reportId: string) =>
    `agency/v1/group-meeting/report/${reportId}`,

  // KPI & Incentive
  IncentiveProgram: () => '/agency/v1/are/incentive/program',
  IncentiveType: () => '/agency/v1/are/incentive/type-project',
  IncentiveReportAre: () => '/agency/v1/are/incentive/report',
  IncentiveReportSpv: () => '/agency/v1/spv/incentive/report',

  // Agency News
  MediaBrochures: () => '/agency/v1/media/spv-brochures',
  MediaSPVBrochures: () => '/agency/v1/media/spv-brochures',
  MediaBMBrochures: () => '/agency/v1/media/bm-brochures',
  MediaAMBrochures: () => '/agency/v1/media/am-brochures',

  // Blacklist
  Ban: () => '/agency/v1/agent/ban',
  Unban: () => '/agency/v1/agent/unban',

  // Branch Routine Checklist
  BranchRoutineSummary: () => '/agency/v1/branch/routine/summary',

  // Activity Dashboard
  ActivityReportSummary: () => '/agency/v1/activity/report/summary',

  // Confins Migration
  SettingManagement: () => '/agency/v1/setting_management',
  SettingManagementRequests: () => '/agency/v1/setting_management/requests',
  SettingManagementLog: (settingManagementId: string) =>
    `/agency/v1/setting_management/changelog/${settingManagementId}`,

  // Media Management (HO-Editor)
  MediaManagementList: () => '/agency/v1/media/brochures/manage',
  MediaManagementUpload: () => '/agency/v1/media/upload',
  MediaManagementCreate: () => '/agency/v1/media/brochures',
  MediaManagementUpdate: (brochureType: string, id: string) =>
    `/agency/v1/media/brochures/${brochureType}/${id}`,
  MediaManagementDelete: (brochureType: string, id: string) =>
    `/agency/v1/media/brochures/${brochureType}/${id}`,

  // Media Management GenFi (HO-Editor)
  MediaManagementGenfiList: () => '/agency/v1/media/genfi',
  MediaManagementGenfiCreate: () => '/agency/v1/media/genfi',
  MediaManagementGenfiDelete: (id: string) => `/agency/v1/media/genfi/${id}`,
  MediaManagementGenfiActiveCarousel: () =>
    '/agency/v1/media/genfi/active-carousel',
  MediaManagementGenfiActivePromotion: () =>
    '/agent-marketing/v1/media/active-promotion-material',
  MediaManagementGenfiActiveTraining: () =>
    '/agent-marketing/v1/media/active-training-material',
  MediaManagementGenfiActiveLoyalty: () =>
    '/agent-marketing/v1/media/active-loyalty-program-material',
};

const HTTPEndPoints = new Proxy(endPointURLs, {
  get(target, name, receiver) {
    if (!Reflect.has(target, name)) {
      return '';
    }
    return (...params: string[]) =>
      Reflect.get(target, name, receiver)(...params);
  },
});

export default HTTPEndPoints;
